import { createGlobalStyle } from 'styled-components';

export const GlobalReset = createGlobalStyle`
  /* Reset all Antd styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    background: transparent !important;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }

  #root {
    height: 100%;
    margin: 0;
    padding: 0;
    background: transparent;
  }

  /* Override any Antd Layout styles */
  .ant-layout,
  .ant-layout-header,
  .ant-layout-content,
  .ant-layout-sider {
    background: transparent !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Ensure our custom styles take precedence */
  div[class*="LayoutMaster"],
  div[class*="LayoutMain"],
  div[class*="MainWrapper"] {
    margin: 0 !important;
    padding: 0 !important;
    background: inherit !important;
  }

  /* Fix for WizardCard top borders - ensure all top elements have proper border radius */
  [class*="StyledCard"] > div:first-child,
  div[class*="StyledCard"] > div:first-child,
  .kzfvVp,
  div[class*="TopColorBar"],
  div[class*="TopGradientBar"] {
    border-radius: 16px 16px 0 0 !important;
  }
  
  /* More specific selectors for wizard cards */
  div[class*="CardContainer"] div:first-child,
  div[class*="WizardCard"] div:first-child {
    border-radius: 16px 16px 0 0 !important;
  }
`;
